import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { sanitizeHtml } from './sanitize-html';

interface ContentProps {
    className?: string;
    serverHtml?: string;
    sanitize?: boolean;
    dataTestId?: string;
}

export const Content = forwardRef<HTMLDivElement, ContentProps>(
    ({ className, serverHtml, sanitize = true, dataTestId = 'html-content' }, ref) =>
        serverHtml ? (
            <div
                ref={ref}
                className={className}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: sanitize ? sanitizeHtml(serverHtml) : serverHtml,
                }}
                data-testid={dataTestId}
            />
        ) : null,
);

Content.displayName = 'Content';

Content.propTypes = {
    serverHtml: PropTypes.string,
    className: PropTypes.string,
    sanitize: PropTypes.bool,
};

Content.defaultProps = {
    serverHtml: undefined,
    className: undefined,
    sanitize: true,
    dataTestId: undefined,
};
